export default {
    path: '*',
    components: {
        default: () => import(/* webpackChunkName: "Error" */ '../pages/Error.vue'),
    }
}